const WinnersActionTypes = Object.freeze({
  FETCH_WINNERS_START: 'winners/FETCH_WINNERS_START',
  FETCH_WINNERS_SUCCESS: 'winners/FETCH_WINNERS_SUCCESS',
  FETCH_WINNERS_FAILURE: 'winners/FETCH_WINNERS_FAILURE',
  FETCH_WINNER_GIFTS_START: 'winners/FETCH_WINNER_GIFTS_START',
  FETCH_WINNER_GIFTS_SUCCESS: 'winners/FETCH_WINNER_GIFTS_SUCCESS',
  FETCH_WINNER_GIFTS_FAILURE: 'winners/FETCH_WINNER_GIFTS_FAILURE',
  CLAIM_WINNER_GIFT_START: 'winners/CLAIM_WINNER_GIFT_START',
  SET_WINNER_STATE: 'winners/SET_STATE',
  SEARCH_COUPON_CODE: 'winners/SEARCH_COUPON_CODE',
  UPDATE_COUPON_CODE: 'winners/UPDATE_COUPON_CODE',
  NEXT_PAGE: 'winners/NEXT_PAGE',
  PREV_PAGE: 'winners/PREV_PAGE',
  RELOAD_PAGE: 'winners/RELOAD_PAGE',
});

export default WinnersActionTypes;
